var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector44325723(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 47,
    viewBox: "0 0 93 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 44325723",
    d: "M82.164 45.7613H62.4137H11.3351C8.83789 44.8825 0.696908 41.4141 1.11937 33.2394C1.80054 20.0584 17.4653 22.6946 16.1024 21.3765C16.5564 20.0584 16.2275 14.4935 20.8699 12.8089C25.5123 11.1243 29.9958 12.8089 32.4475 14.7861C32.999 15.2308 32.4475 2.26416 43.3443 0.946072C57.6463 -0.783926 58.2422 13.468 59.0084 12.8089C61.0516 11.0515 64.4568 7.18168 71.9483 8.85464C80.1209 10.6797 81.029 18.5207 80.1209 22.0356C78.7588 22.6946 89.6555 21.3765 91.6987 31.9213C93.2311 39.8299 86.2503 43.7841 82.164 45.7613Z",
    fill: "white",
    stroke: "#00004B",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector44325723);
export default __webpack_public_path__ + "static/media/Vector 44325723.4301d7dcd6d71854fc8b02783b576a06.svg";
export { ForwardRef as ReactComponent };